import axios from '@fs/zion-axios'

export const EXPERIENCE_URL = '/service/discovery/incenterexperience/experience'

const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value)

// GET /experience answers { data: <blob>, completed }. A 404 means this session has no experience yet.
export const getExperienceBlob = async () => {
  try {
    const response = await axios.get(EXPERIENCE_URL)
    const blob = response?.data?.data
    return isPlainObject(blob) ? blob : {}
  } catch (error) {
    if (error?.response?.status === 404) return {}
    throw error
  }
}

// PUT /experience replaces the whole blob, so every writer merges into what is there. Each writer
// owns its own top-level key; the rest are carried through untouched. The service rejects any body
// without an onboardingAnswers object, so a write that does not own it still sends one: the current
// answers, the legacy visitorData answers, or an empty object.
//
// Two writers queue their own GET-merge-PUTs independently: usePutExperience (onboardingAnswers) and
// the Guest Family store (guestFamily). Neither waits for the other, so an interleaved pair can send
// stale onboardingAnswers. That is accepted: one Patron uses one kiosk, so the two rarely overlap.
export const putExperienceBlob = async (update) => {
  const current = await getExperienceBlob()
  const { visitorData, ...rest } = current
  const onboardingAnswers = [rest.onboardingAnswers, visitorData].find(isPlainObject) ?? {}
  return axios.put(EXPERIENCE_URL, { ...rest, onboardingAnswers, ...update })
}
